// extracted by mini-css-extract-plugin
export var carousel = "style-module--carousel--18616";
export var copy = "style-module--copy--df4f8";
export var introduction = "style-module--introduction--d043e";
export var introductionSp = "style-module--introductionSp--620d3";
export var lead = "style-module--lead--65cbe";
export var link = "style-module--link--09322";
export var logoContainer = "style-module--logoContainer--e11ab";
export var scroll = "style-module--scroll--6f89b";
export var section = "style-module--section--6cfc0";